module.exports = __webpack_public_path__ + "static/logo-80b8335b92a58a9834ad25f04f04946e.png";